import { render } from "./customerstories.vue?vue&type=template&id=7f1d5a5c&scoped=true"
import script from "./customerstories.vue?vue&type=script&lang=js"
export * from "./customerstories.vue?vue&type=script&lang=js"

import "./customerstories.vue?vue&type=style&index=0&id=7f1d5a5c&lang=css"
import "./customerstories.vue?vue&type=style&index=1&id=7f1d5a5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1d5a5c"]])

export default __exports__